import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<typeof categories[0] | null>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (category: typeof categories[0]) => {
    setSelectedCategory(category);
    setIsOpen(false);
    window.open(category.url, '_blank', 'noopener,nofollow');
  };

  return (
    <section id="categories" className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-3">
            Przeglądaj kategorie produktów
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            Wybierz kategorię i odkryj najlepsze produkty Kakobuy
          </p>
        </div>

        <div ref={dropdownRef} className="relative w-full">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="w-full flex items-center justify-between px-5 py-4 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-800 hover:border-primary-300 transition-all duration-200 cursor-pointer"
          >
            <span className={selectedCategory ? 'text-foreground-900' : 'text-foreground-500'}>
              {selectedCategory ? `${selectedCategory.name} (${selectedCategory.namePl})` : 'Wybierz kategorię produktów...'}
            </span>
            <i className={`ri-arrow-down-s-line text-lg text-foreground-500 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}></i>
          </button>

          {isOpen && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200/70 rounded-lg shadow-lg overflow-hidden z-40 max-h-[360px] overflow-y-auto">
              {categories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => handleSelect(cat)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-800 hover:bg-primary-50 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
                >
                  <span className="w-8 h-8 flex items-center justify-center text-primary-500">
                    <i className={`${cat.icon} text-lg`}></i>
                  </span>
                  <div className="text-left">
                    <span className="font-medium">{cat.name}</span>
                    <span className="text-foreground-500 ml-2">({cat.namePl})</span>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}